import produce from "immer";
import React from "react";
import Checkbox from "../refresh/inputs/Checkbox";
import ImageSelectorButton from "../refresh/selectors/ImageSelectorButton";
import Label from "../refresh/Label";
import RedButton from "../refresh/RedButton";
import TextInput from "../refresh/inputs/TextInput";

const MovementOptions = ({
  editing,
  config,
  setConfig,
  images,
  onComplete,
}) => {
  return (
    <>
      {!editing && (
        <>
          <hr />
          <Label name="Image" required>
            <ImageSelectorButton
              value={config.options?.id}
              onChange={image =>
                setConfig(
                  produce(draft => {
                    draft.options.id = image.id;
                    draft.tooltip = image.name;
                  }),
                )
              }
              images={images}
            />
          </Label>
          <Checkbox
            value={config.boomerang}
            onChange={boomerang =>
              setConfig(
                produce(draft => {
                  draft.boomerang = boomerang;
                }),
              )
            }
          >
            Add Boomerang
          </Checkbox>
          {config.boomerang && (
            <>
              <hr />
              <h2>Boomerang Options</h2>
              <TextInput
                label="Return tooltip"
                required
                value={config.targetToolTip}
                onChange={targetToolTip =>
                  setConfig(
                    produce(draft => {
                      draft.targetToolTip = targetToolTip;
                    }),
                  )
                }
              />
            </>
          )}
        </>
      )}
      <RedButton
        disabled={
          !(
            config.tooltip &&
            config.options?.id &&
            (!config.boomerang || config.targetToolTip)
          )
        }
        onClick={() => onComplete(config)}
      >
        Save
      </RedButton>
    </>
  );
};

export default MovementOptions;
